let locked

export const lock = async () => {
  const { navigator } = globalThis
  const { wakeLock } = navigator

  if (locked) {
    throw new Error('screen is already locked')
  }

  try {
    locked = await wakeLock?.request('screen')
  } catch ({ name, message }) {
    console.error(`${name}`, `${message}`)
  }
}

export const unlock = async () => {
  locked = await locked?.release()
}
